import moment from "moment-timezone"

import { MINUTES_STEP } from "../constants"

export const getNowDate = () => {
  const now = moment().seconds(0)
  const remainder = MINUTES_STEP - (now.minute() % MINUTES_STEP)
  return moment(now).add(remainder, "minutes")
}
